import React from "react";
import * as http from "http";

export default React.createContext<http.ServerResponse | null>(null);
